import { useTheme } from '@material-ui/core/styles';
import imgLogoDarkmode from '@pe-libs/react-components/build/assets/common/logos/logo-darkmode.svg';
import imgLogo from '@pe-libs/react-components/build/assets/common/logos/logo.svg';
import PeImage from '@pe-libs/react-components/build/components/PeImage';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC, memo, useEffect, useState } from 'react';
import messages from './messages';
import useStyles from './styles';

const PeContentLayoutLogo: FC = () => {
  const formatMessage = useIntlMessage();
  const styles = useStyles({
    avatarUrl: '',
  });
  const theme = useTheme();

  const [imageHeight, setImageHeight] = useState(75);

  useEffect(() => {
    const updateHeight = () => {
      const calculatedHeight = Math.floor(window.innerHeight * 0.07);
      const newHeight = Math.max(Math.min(calculatedHeight, 75), 55);

      setImageHeight(newHeight);
    };

    updateHeight();

    window.addEventListener('resize', updateHeight);

    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <div className={styles.logo}>
      <PeImage
        width={254}
        height={imageHeight}
        layout="fixed"
        alt={formatMessage(messages.altImgLogo)}
        src={theme.palette.type === 'dark' ? (imgLogoDarkmode as string) : (imgLogo as string)}
      />
    </div>
  );
};

export default memo(PeContentLayoutLogo);
